"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Icon_1 = __importDefault(require("../../../Icon"));
var useStyles_1 = __importDefault(require("./useStyles"));
var Icon = function () {
    var _a;
    var classes = (0, useStyles_1.default)();
    return (react_1.default.createElement(Icon_1.default, { kind: "dragIndicator", classes: {
            root: (0, classnames_1.default)((_a = {},
                _a[classes.icon] = true,
                _a))
        } }));
};
exports.default = Icon;
